import { jwtDecode } from "jwt-decode";
import { useLocalStorage } from "@shared/lib/hooks/use-local-storage";

export function useLocalUser() {
  const [newToken] = useLocalStorage("newToken");

  if (!newToken) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { email, lastName, firstName, middleName, user_id } = jwtDecode<{
    email: string;
    lastName: string;
    firstName: string;
    middleName: string;
    user_id: string;
  }>(newToken);

  return {
    email,
    lastName,
    firstName,
    middleName,
    user_id,
  };
}
